<template>
  <div>
    <div class="profile-info-block">
      <div class="profile-edit-block">
        <h2 class="rg-title">職歴</h2>
          <EditButton
            title="編集"
            @click="showModal"
          />
      </div>
      <div class="profile-info">
        <table class="table" style="table-layout: fixed">
          <tbody>
            <tr>
              <th>直近在籍企業名</th>
              <td>
                <span class="edit-txt" v-if="isEmploymentEdit">{{
                  profile.recent_registered_company_name
                }}</span>
              </td>
            </tr>
            <tr>
              <th>在籍期間</th>
              <td>
                <span class="edit-txt" v-if="isEmploymentEdit">
                  {{
                    profile.currently_enrolled
                      ? `${enrollment_period.from.year}年${enrollment_period.from.month}月 ~ `
                      : `${enrollment_period.from.year}年${enrollment_period.from.month}月 ~ ${enrollment_period.to.year}年${enrollment_period.to.month}月`
                  }}
                </span>
              </td>
            </tr>
            <tr>
              <th>直近職種 (大分類)</th>
              <td>
                <span class="edit-txt" v-if="isEmploymentEdit">{{
                  getMainOccupation(profile.latest_occupation_main_title)
                }}</span>
              </td>
            </tr>
            <tr>
              <th>直近職種 (中分類)</th>
              <td>
                <span class="edit-txt" v-if="isEmploymentEdit">
                  {{
                    getChildOccupation(
                      profile.latest_occupation_main_title,
                      profile.latest_occupation_sub_title
                    )
                  }}
                </span>
              </td>
            </tr>
            <tr>
              <th>雇用形態</th>
              <td>
                <span class="edit-txt" v-if="isEmploymentEdit">{{
                  getStatus(profile.employment_status)
                }}</span>
              </td>
            </tr>
            <tr>
              <th>役職</th>
              <td>
                <span class="edit-txt" v-if="isEmploymentEdit">{{
                  getPosition(profile.position)
                }}</span>
              </td>
            </tr>
            <tr>
              <th>英語力</th>
              <td>
                <span class="edit-txt" v-if="isEmploymentEdit">{{
                  getEnglishSkill(profile.english_skills)
                }}</span>
              </td>
            </tr>
            <tr>
              <th>直近年収 (万円)</th>
              <td>
                <span class="edit-txt" v-if="isEmploymentEdit">{{
                  profile.last_year_income
                }}</span>
              </td>
            </tr>
            <tr>
              <th>これまでの経験社数</th>
              <td>
                <span class="edit-txt" v-if="isEmploymentEdit">{{
                  profile.number_of_experience_companies
                }}</span>
              </td>
            </tr>
            <tr>
              <th>
                職務要約<span v-if="!isEmploymentEdit" class="text-danger"
                  >*</span
                >
              </th>
              <td>
                <span
                  class="edit-txt"
                  v-if="isEmploymentEdit"
                  style="white-space: pre-wrap !important"
                  >{{ profile.job_summary }}</span
                >
              </td>
            </tr>
            <tr>
              <th>職務経歴書</th>

              <td>
                <span class="edit-txt resume-txt" v-if="isEmploymentEdit">
                  <a
                    v-if="profile.resume !== ''"
                    href="#"
                    @click="previewFile($event, 'resume')"
                    class="preview-resume"
                    >{{ getFileName(profile.resume) }}</a
                  >
                </span>
              </td>
            </tr>
            <tr>
              <th>履歴書</th>
              <td>
                <span class="edit-txt resume-txt" v-if="isEmploymentEdit" style="word-break:break-all">
                  <a
                    v-if="profile.cv !== ''"
                    href="#"
                    @click="previewFile($event, 'cv')"
                    class="preview-resume"
                    >{{ getFileName(profile.cv) }}</a
                  >
                </span>
              </td>
            </tr>
            <tr>
              <!--<th>今後ご転職された場合に叶えたいことや、こだわり等あればお聞かせください</th>-->
              <th>
                配慮事項について
              </th>
              <td>
                <span
                  class="edit-txt"
                  v-if="isEmploymentEdit"
                  style="white-space: pre-wrap !important"
                  >{{ profile.career_change_reason }}</span
                >
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <b-modal
      id="modal1"
      ref="modal"
      hide-footer
      size="lg"
      :no-close-on-esc="true"
      :no-close-on-backdrop="true"
      @shown="addEventListeners"
      @hide="removeEventListeners"
    >
      <template #modal-header>
        <!-- Emulate built in modal header close button action -->
        <h5 class="sharingTitle" style="margin-top:5px">
          職歴
        </h5>
        <!-- <img
          src="../assets/close.png"
          v-on:click.prevent="cancel()"
          style="cursor:pointer;margin-top:5px"
        /> -->
        <!-- <button
          data-v-bf1681ae=""
          title="保存"
          class="btn btn-secondary rounded font-16 profile-edit-btn"
          @click="saveEmployment"
        >
          保存
        </button> -->
      </template>
      <form v-on:submit.prevent="saveEmployment" data-vv-scope="employment" style="max-height: 550px;overflow-y:scroll;">
        <div class="form-sep-block">
          <div class="item-form-block">
            <div class="form-group row">
              <div class="col-md-12 mb-30">
                <label class="cstm-label">
                  <span class="span-badge mr-2">必須</span>
                  直近在籍企業名
                </label>
                <input
                  type="text"
                  class="form-control"
                  v-bind:class="{
                    'is-invalid': hasError(
                      'recent_registered_company_name',
                      'employment'
                    ),
                  }"
                  name="recent_registered_company_name"
                  v-model="profile.recent_registered_company_name"
                  v-validate="'required|max:50'"
                  data-vv-as="直近在籍企業名"
                />

                <div
                  class="invalid-feedback"
                  v-if="
                    hasError('recent_registered_company_name', 'employment')
                  "
                >
                   
                  {{
                    getErrorMessage(
                      "recent_registered_company_name",
                      "employment"
                    )
                  }}
                </div>
              </div>

              <div class="col-md-12 mb-30">
                <label class="cstm-label">
                  <span class="span-badge mr-2">必須</span>
                  在籍期間
                </label>
                <div>
                  <input
                    type="checkbox"
                    id="currently_enrolled"
                    class="form-check-inline"
                    name="currently_enrolled"
                    v-model="profile.currently_enrolled"
                  />
                  <label for="currently_enrolled" class="font-15">在籍中</label>
                  <div
                    class="d-flex justify-content-between slct-inline enrolled-date"
                  >
                    <div class="d-inline-flex flex-basis-100">
                      <select
                        class="form-control"
                        v-bind:class="{
                          'is-invalid': hasError(
                            'enrollment_period_from',
                            'employment'
                          ),
                        }"
                        name="enrollment_period_from"
                        id="from_year"
                        v-model="enrollment_period.from.year"
                        v-validate="'required'"
                        data-vv-as="在籍開始年月"
                      >
                        <option value=""></option>
                        <option
                          v-for="year in enrollmentYears"
                          v-bind:key="year"
                          v-bind:value="year"
                        >
                          {{ year }}
                        </option>
                      </select>
                      <label for="from_year">年</label>

                      <select
                        class="form-control"
                        v-bind:class="{
                          'is-invalid': hasError(
                            'enrollment_period_from',
                            'employment'
                          ),
                        }"
                        name="enrollment_period_from"
                        id="from_month"
                        v-model="enrollment_period.from.month"
                        v-validate="'required'"
                        data-vv-as="在籍開始年月"
                      >
                        <option value=""></option>
                        <option
                          v-for="month in months"
                          v-bind:key="month"
                          v-bind:value="month"
                        >
                          {{ month }}
                        </option>
                      </select>
                      <label for="from_month">月</label>
                    </div>
                    <span class="">~</span>
                    <div class="d-inline-flex flex-basis-100">
                      <select
                        class="form-control"
                        v-bind:class="{
                          'is-invalid': hasError('enrollment_period_to'),
                          'disable-select': profile.currently_enrolled,
                        }"
                        name="enrollment_period_to"
                        id="to_year"
                        v-model="enrollment_period.to.year"
                        v-validate="{ required: !profile.currently_enrolled }"
                        data-vv-as="在籍終了年月"
                        :disabled="profile.currently_enrolled"
                      >
                        <option value=""></option>
                        <option
                          v-for="year in enrollmentYears"
                          v-bind:key="year"
                          v-bind:value="year"
                        >
                          {{ year }}
                        </option>
                      </select>
                      <label for="to_year">年</label>

                      <select
                        class="form-control"
                        v-bind:class="{
                          'is-invalid': hasError(
                            'enrollment_period_to',
                            'employment'
                          ),
                          'disable-select': profile.currently_enrolled,
                        }"
                        name="enrollment_period_to"
                        id="to_month"
                        v-model="enrollment_period.to.month"
                        v-validate="{ required: !profile.currently_enrolled }"
                        data-vv-as="在籍終了年月"
                        :disabled="profile.currently_enrolled"
                      >
                        <option value=""></option>
                        <option
                          v-for="month in months"
                          v-bind:key="month"
                          v-bind:value="month"
                        >
                          {{ month }}
                        </option>
                      </select>
                      <label for="to_month">月</label>
                    </div>
                  </div>
                  <div
                    class="invalid-feedback flex-column align-items-start"
                    v-if="
                      hasError('enrollment_period_from', 'employment') ||
                        hasError('enrollment_period_to', 'employment')
                    "
                  >
                    <div
                      v-if="hasError('enrollment_period_from', 'employment')"
                    >
                      {{
                        getErrorMessage("enrollment_period_from", "employment")
                      }}
                    </div>
                    <div v-if="hasError('enrollment_period_to', 'employment')">
                      {{
                        getErrorMessage("enrollment_period_to", "employment")
                      }}
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-12 mb-30">
                <label class="cstm-label">
                  <span class="span-badge mr-2">必須</span>
                  直近職種 (大分類)
                </label>
                <div class="d-flex justify-content-between flex-column">
                  <select
                    class="form-control  "
                    v-bind:class="{
                      'is-invalid': hasError(
                        'latest_occupation_main_title',
                        'employment'
                      ),
                    }"
                    name="latest_occupation_main_title"
                    v-model="profile.latest_occupation_main_title"
                    v-validate="'required'"
                    data-vv-as="直近職種 （大分類）"
                  >
                    <option value>選択</option>
                    <option
                      v-for="occupation in data.latestOccupation"
                      v-bind:key="occupation._id"
                      v-bind:value="occupation._id"
                    >
                      {{ occupation.title }}
                    </option>
                  </select>
                  <div
                    class="invalid-feedback"
                    v-if="
                      hasError('latest_occupation_main_title', 'employment')
                    "
                  >
                     
                    {{
                      getErrorMessage(
                        "latest_occupation_main_title",
                        "employment"
                      )
                    }}
                  </div>
                </div>
              </div>

              <div class="col-md-12 mb-30">
                <label class="cstm-label">
                  <span class="span-badge mr-2">必須</span>
                  直近職種 (中分類)
                </label>
                <div class="d-flex justify-content-between flex-column">
                  <select
                    class="form-control  "
                    v-bind:class="{
                      'is-invalid': hasError(
                        'latest_occupation_sub_title',
                        'employment'
                      ),
                    }"
                    name="latest_occupation_sub_title"
                    v-model="profile.latest_occupation_sub_title"
                    v-validate="'required'"
                    data-vv-as="直近職種（中分類）"
                  >
                    <option value>選択</option>
                    <option
                      v-for="occupation in latestOccupationChilds"
                      v-bind:key="occupation._id"
                      v-bind:value="occupation._id"
                    >
                      {{ occupation.title }}
                    </option>
                  </select>
                  <div
                    class="invalid-feedback"
                    v-if="hasError('latest_occupation_sub_title', 'employment')"
                  >
                     
                    {{
                      getErrorMessage(
                        "latest_occupation_sub_title",
                        "employment"
                      )
                    }}
                  </div>
                </div>
              </div>

              <div class="col-md-12 mb-30">
                <label class="cstm-label">
                  <span class="span-badge mr-2">必須</span>
                  雇用形態
                </label>
                <div class="d-flex justify-content-between flex-column">
                  <select
                    class="form-control  "
                    v-bind:class="{
                      'is-invalid': hasError('employment_status', 'employment'),
                    }"
                    name="employment_status"
                    v-model="profile.employment_status"
                    v-validate="'required'"
                    data-vv-as="雇用形態"
                  >
                    <option value>選択</option>
                    <option
                      v-for="status in data.status"
                      v-bind:key="status._id"
                      v-bind:value="status._id"
                    >
                      {{ status.title }}
                    </option>
                  </select>
                  <div
                    class="invalid-feedback"
                    v-if="hasError('employment_status', 'employment')"
                  >
                     
                    {{ getErrorMessage("employment_status", "employment") }}
                  </div>
                </div>
              </div>

              <div class="col-md-12 mb-30">
                <label class="cstm-label">
                  <span class="span-badge badge-option mr-2">任意</span>
                  役職
                </label>
                <div class="d-flex justify-content-between flex-column">
                  <select
                    class="form-control is-valid"
                    v-bind:class="{
                      'is-invalid': hasError('position', 'employment'),
                    }"
                    name="position"
                    v-model="profile.position"
                    data-vv-as="役職"
                  >
                    <option value>選択</option>
                    <option
                      v-for="position in data.position"
                      v-bind:key="position._id"
                      v-bind:value="position._id"
                    >
                      {{ position.title }}
                    </option>
                  </select>
                  <div
                    class="invalid-feedback"
                    v-if="hasError('position', 'employment')"
                  >
                     
                    {{ getErrorMessage("position", "employment") }}
                  </div>
                </div>
              </div>

              <div class="col-md-12 mb-30">
                <label class="cstm-label">
                  <span class="span-badge mr-2">必須</span>
                  英語力
                </label>
                <div class="d-flex justify-content-between flex-column">
                  <select
                    class="form-control  "
                    v-bind:class="{
                      'is-invalid': hasError('english_skills', 'employment'),
                    }"
                    name="english_skills"
                    v-model="profile.english_skills"
                    v-validate="'required'"
                    data-vv-as="英語力"
                  >
                    <option value>選択</option>
                    <option
                      v-for="englishSkill in data.englishSkill"
                      v-bind:key="englishSkill._id"
                      v-bind:value="englishSkill._id"
                    >
                      {{ englishSkill.title }}
                    </option>
                  </select>
                  <div
                    class="invalid-feedback"
                    v-if="hasError('english_skills', 'employment')"
                  >
                     
                    {{ getErrorMessage("english_skills", "employment") }}
                  </div>
                </div>
              </div>

              <div class="col-md-12 mb-30">
                <label class="cstm-label">
                  <span class="span-badge mr-2">必須</span>
                  直近年収 (万円)
                </label>
                <input
                  type="number"
                  class="form-control  "
                  v-bind:class="{
                    'is-invalid': hasError('last_year_income', 'employment'),
                  }"
                  name="last_year_income"
                  v-model="profile.last_year_income"
                  v-validate="'required|max:50'"
                  data-vv-as="直近年収 (万円)"
                  min="0"
                  onkeypress="return event.charCode >= 48"
                />

                <div
                  class="invalid-feedback"
                  v-if="hasError('last_year_income', 'employment')"
                >
                   
                  {{ getErrorMessage("last_year_income", "employment") }}
                </div>
              </div>

              <div class="col-md-12 mb-30">
                <label class="cstm-label">
                  <span class="span-badge mr-2">必須</span>
                  これまでの経験社数
                </label>
                <input
                  type="number"
                  class="form-control  "
                  v-bind:class="{
                    'is-invalid': hasError(
                      'number_of_experience_companies',
                      'employment'
                    ),
                  }"
                  name="number_of_experience_companies"
                  v-model="profile.number_of_experience_companies"
                  v-validate="'required|max:50'"
                  data-vv-as="これまでの経験社数"
                  min="0"
                  onkeypress="return event.charCode >= 48"
                />

                <div
                  class="invalid-feedback"
                  v-if="
                    hasError('number_of_experience_companies', 'employment')
                  "
                >
                   
                  {{
                    getErrorMessage(
                      "number_of_experience_companies",
                      "employment"
                    )
                  }}
                </div>
              </div>

              <div class="col-md-12 mb-30 resume-group">
                <label class="cstm-label">
                  <span class="span-badge mr-2">必須</span>
                  職務経歴について
                </label>
                <div class="input-group">
                  <input
                    type="file"
                    id="upld"
                    name="resume"
                    v-on:change="onFileChanged"
                    v-bind:class="{
                      'is-invalid': hasError('resume'),
                    }"
                    v-validate.immediate="
                      profile.resume
                        ? 'ext:pdf|size:1024'
                        : ''
                    "
                    accept=".pdf"
                    ref="inputFile"
                    style="display: none;"
                  />
                </div>
                <!-- <div class="row mt-2"> -->
                  <div class="button-wrapper" style="cursor: pointer;">
                    <button
                      class="btn btn-cstm-sm btn-cv-submit"
                      @click.prevent="openFileExplorer('resume')"
                    >
                      職務経歴書をアップロードする
                    </button>
                  </div>
                <!-- </div> -->
                <!-- <div class="row mt-2"> -->
                  <div class="upld-file-name mb-3 pb-1" id="resume" v-if="profile.resume !== ''">
                    <p>{{ getFileName(profile.resume) }}</p>
                    <i class="fas fa-times" aria-hidden="true" style="font-size: 25px;margin-top:10px;" @click="onClickDeleteFile"></i>
                  </div>
                <!-- </div> -->
                <div
                  class="invalid-feedback"
                  v-if="hasError('resume', 'employment')"
                >
                   
                  {{ getErrorMessage("resume", "employment") }}
                </div>
              </div>

              <div class="col-md-12">
                <div class="file-instr">
                  <p>
                    <span style="color:#3d3d3d;"
                      >※アップロードした内容は、あなたがキャリア登録先として選択した企業に公開されます。</span
                    ><br />
                    ※ 1MB未満のPDFのアップロードが可能です。<br />
                    ※
                    パスワードを設定したPDFはアップロードできません。<br />
                    ※ 志望動機の記入は不要です。
                  </p>
                </div>
              </div>

              <div class="col-md-12 mb-30 resume-group">
                <textarea
                  class="form-control  "
                  rows="4"
                  v-bind:class="{
                    'is-invalid': hasError('job_summary', 'employment'),
                  }"
                  name="job_summary"
                  v-model="profile.job_summary"
                  ref="jobSummary_ref"
                  data-vv-as="職務要約"
                  :placeholder="jobSummaryPlaceholder"
                  v-validate.immediate="
                      profile.resume
                        ? ''
                        : 'required'
                    "
                />
                <div
                  class="invalid-feedback"
                  v-if="hasError('job_summary', 'employment')"
                >
                   
                  {{ getErrorMessage("job_summary", "employment") }}
                </div>
              </div>

              <div class="col-md-12 mb-30 resume-group">
                <label class="cstm-label">
                  <span class="span-badge badge-option mr-2">任意</span>
                  履歴書
                </label>
                <div class="input-group">
                  <input
                    type="file"
                    id="cv_pdf"
                    name="cv"
                    v-on:change="onCVFileChanged"
                    v-bind:class="{
                      'is-invalid': hasError('cv'),
                    }"
                    v-validate.immediate="profile.cv ? 'ext:pdf|size:1024': ''"
                    accept=".pdf"
                    ref="cv_file"
                    style="display: none;"
                  />
                </div>
                  <div class="button-wrapper" style="cursor: pointer;">
                    <button
                      class="btn btn-cstm-sm btn-cv-submit"
                      @click.prevent="openFileExplorer('cv')"
                    >
                      履歴書をアップロードする
                    </button>
                  </div>
                  <div class="upld-file-name mb-3 pb-1" id="cv" v-if="profile.cv !== ''">
                    <p>{{ getFileName(profile.cv) }}</p>
                    <i class="fas fa-times" aria-hidden="true" style="font-size: 25px;margin-top:10px;margin-left:10px" @click="onCVDeleteFile"></i>
                  </div>
                  <div
                    class="invalid-feedback"
                    v-if="hasError('cv', 'employment')"
                  >
                    
                    {{ getErrorMessage("cv", "employment") }}
                  </div>
                </div>

              <div class="col-md-12 mb-30">
                <label class="cstm-label">
                  <span class="span-badge badge-option mr-2">任意</span>
                  配慮事項について
                </label>
                <textarea
                  class="form-control  "
                  rows="4"
                  v-bind:class="{
                    'is-invalid': hasError(
                      'career_change_reason',
                      'employment'
                    ),
                  }"
                  name="career_change_reason"
                  v-model="profile.career_change_reason"
                  data-vv-as="配慮事項について"
                  placeholder="転職時期・勤務地・給与等、特に配慮してほしい事項がある方は、ここに入力してください。"
                />

                <div
                  class="invalid-feedback"
                  v-if="hasError('career_change_reason', 'employment')"
                >
                   
                  {{ getErrorMessage("career_change_reason", "employment") }}
                </div>
              </div>
              <div class="col-md-12 text-center">
                <button
                    data-v-bf1681ae=""
                    title="保存"
                    class="btn btn-secondary rounded font-16 profile-edit-btn"
                    @click.prevent="saveEmployment"
                  >
                  この内容で保存する
                </button>
                <CancelModal @click="cancel" />
              </div>
            </div>
          </div>
        </div>
      </form>
      <!-- ends custom-form-block -->
    </b-modal>
  </div>
</template>
<script>
import Api from "@/config/api";
import moment from "moment";
import { mapActions, mapGetters } from "vuex";
import swal from "sweetalert";
import logo from "../assets/Group300.png";
import modalEventListener from "../mixins/modalEventListener";
import CancelModal from "./CancelModal.vue";
import EditButton from "./EditButton.vue";

export default {
  name: "Employment",
  mixins: [modalEventListener],
  components: { CancelModal, EditButton },
  props: ["data","isFileUploadredirect"],
  data() {
    return {
      server_errors: {},
      isEmploymentEdit: true,
      selectedCursor: "pointer",
      latestOccupationChilds: [],
      tempEmploymentData: {},
      years: [],
      months: [
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
      ],
      days: [
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
        "21",
        "22",
        "23",
        "24",
        "25",
        "26",
        "27",
        "28",
        "29",
        "30",
        "31",
      ],
      enrollmentYears: [],
      enrollment_period: {
        from: {
          year: "",
          month: "",
        },
        to: {
          year: "",
          month: "",
        },
      },
      deleteResume: false,
      tempResume: "",
      deleteCV: false,
      tempCV: "",
    };
  },
  watch: {
    // eslint-disable-next-line
    "profile.latest_occupation_main_title": function(val) {
      if (val.trim()) {
        if (this.data.latestOccupation) {
          const parent = this.data.latestOccupation.find(
            ({ _id }) => _id === val
          );
          if (parent) {
            this.latestOccupationChilds = parent.children
              .filter((child) => child.status !== false)
              .sort((a, b) => a.position - b.position);
            const child = this.latestOccupationChilds.find(
              ({ _id }) => _id === this.profile.latest_occupation_sub_title
            );
            if (!child) this.profile.latest_occupation_sub_title = "";
          }
        }
      } else {
        this.latestOccupationChilds = [];
      }
    },
    "enrollment_period.from.year": function() {
      this.updateProfileEnrollment_from();
    },
    "enrollment_period.from.month": function() {
      this.updateProfileEnrollment_from();
    },
    "enrollment_period.to.year": function() {
      this.updateProfileEnrollment_to();
    },
    "enrollment_period.to.month": function() {
      this.updateProfileEnrollment_to();
    },
    "profile.currently_enrolled": function(newVal, oldVal) {
      const enrolled = {
        from: {
          year: this.enrollment_period.from.year,
          month: this.enrollment_period.from.month,
        },
        to: {
          year: "",
          month: "",
        },
      };

      if (
        !newVal &&
        this.tempEmploymentData.enrollment_period_to &&
        typeof this.tempEmploymentData.enrollment_period_to === "string"
      ) {
        const [
          toYear,
          toMonth,
        ] = this.tempEmploymentData.enrollment_period_to.split("/");
        enrolled.to.year = toYear;
        enrolled.to.month = toMonth;
      }

      this.enrollment_period = { ...enrolled };
    },
  },
  computed: {
    ...mapGetters({
      profile: "getProfile",
    }),
    birthDate() {
      return moment(this.profile.birth_date).format("YYYY/MM/DD");
    },
    jobSummaryPlaceholder() {
      return `職務経歴書が無い方は、ここに具体的な業務内容を入力してください。\n 補足資料（ポートフォリオ・英文レジュメ等）がある方は、公開リンクを入力してください。`;
    },
  },
  methods: {
    ...mapActions({}),
    formatDate(date, format = "YYYY-MM-DD") {
      // console.log(date);
      return moment(date)
        .utc()
        .format(format);
    },
    openFileExplorer(type) {
      return type === "resume"
        ? this.$refs.inputFile.click()
        : this.$refs.cv_file.click();
    },
    showModal() {
      this.toggleEdit();
      this.$refs.modal.show();
    },
    updateProfileEnrollment_from() {
      this.clearServerError("enrollment_period_from");
      this.profile.enrollment_period_from = `${this.enrollment_period.from.year}/${this.enrollment_period.from.month}`;
    },
    updateProfileEnrollment_to() {
      this.clearServerError("enrollment_period_to");
      this.profile.enrollment_period_to = `${this.enrollment_period.to.year}/${this.enrollment_period.to.month}`;
    },
    init_enrollment_period() {
      const d = new Date();
      const n = d.getFullYear();
      let j = 0;
      for (let i = n - 70; i <= n; i += 1) {
        this.enrollmentYears[j] = i;
        j += 1;
      }

      const fromDate = new Date(this.profile.enrollment_period_from);
      this.enrollment_period.from.year = String(
        fromDate.getFullYear() || "2013"
      );
      this.enrollment_period.from.month = !isNaN(fromDate.getMonth())
        ? `00${fromDate.getMonth() + 1}`.slice(-2)
        : "";
      if (!this.profile.currently_enrolled) {
        const toDate = new Date(this.profile.enrollment_period_to);
        this.enrollment_period.to.year = String(toDate.getFullYear() || "2013");
        this.enrollment_period.to.month = !isNaN(toDate.getMonth())
          ? `00${toDate.getMonth() + 1}`.slice(-2)
          : "";
      }
    },
    hasError(field, scope = null) {
      return (
        field in this.server_errors || this.errors.first(`${scope}.${field}`)
      );
    },
    getErrorMessage(field, scope = null) {
      if (field in this.server_errors) return this.server_errors[field].msg;
      else if (this.errors.first(`${scope}.${field}`)) {
        return this.errors.first(`${scope}.${field}`);
      }
      return null;
    },
    getStatus(id) {
      if (this.data.status) {
        const result = this.data.status.find(({ _id }) => _id === id);
        if (result) return result.title;
      }
      return "";
    },
    getEnglishSkill(id) {
      if (this.data.englishSkill) {
        const result = this.data.englishSkill.find(({ _id }) => _id === id);
        if (result) return result.title;
      }
      return "";
    },
    getPosition(id) {
      if (this.data.position) {
        const result = this.data.position.find(({ _id }) => _id === id);
        if (result) return result.title;
      }
      return "";
    },
    getScreeningIntention(id) {
      if (this.data.screeningIntention) {
        const result = this.data.screeningIntention.find(
          ({ _id }) => _id === id
        );
        if (result) return result.title;
      }
      return "";
    },
    getJobHistoryRecord(id) {
      if (this.data.jobHistoryRecord) {
        const result = this.data.jobHistoryRecord.find(({ _id }) => _id === id);
        if (result) return result.title;
      }
      return "";
    },
    getMainOccupation(id) {
      // console.log(this.data);
      if (this.data.allOccupation) {
        const result = this.data.allOccupation.find(({ _id }) => _id === id);
        // console.log(result);
        if (result) return result.title;
      }
      return "";
    },
    getChildOccupation(parentId, childId) {
      if (this.data.allOccupation) {
        const parent = this.data.allOccupation.find(
          ({ _id }) => _id === parentId
        );
        if (parent) {
          const result = parent.children.find(({ _id }) => _id === childId);
          if (result) return result.title;
        }
      }
      return "";
    },
    checkDiff(actualData, changedData) {
      for (const key of Object.keys(changedData)) {
        if (actualData[key] !== changedData[key]) {
          return true;
        }
      }
      return false;
    },
    async saveEmployment() {
      const employmentData = {
        recent_registered_company_name: this.profile
          .recent_registered_company_name,
        // years_of_attendance: this.profile.years_of_attendance,
        latest_occupation_main_title: this.profile.latest_occupation_main_title,
        latest_occupation_sub_title: this.profile.latest_occupation_sub_title,
        employment_status: this.profile.employment_status,
        position: this.profile.position,
        english_skills: this.profile.english_skills,
        last_year_income: this.profile.last_year_income,
        number_of_experience_companies: this.profile
          .number_of_experience_companies,
        // current_employment_situation: this.profile.current_employment_situation,
        job_summary: this.profile.job_summary,
        career_change_reason: this.profile.career_change_reason,
        screening_intention: this.profile.screening_intention,
        deleteResume: this.deleteResume,
        deleteCV: this.deleteCV,
        currently_enrolled: this.profile.currently_enrolled,
        enrollment_period_from: this.profile.enrollment_period_from,
        enrollment_period_to: this.profile.enrollment_period_to,
        // job_history_record: this.profile.job_history_record,
      };

      const changedData = { ...employmentData };
      delete changedData.deleteResume;
      delete changedData.deleteCV;

      const actualData = { ...this.tempEmploymentData };
      delete actualData.resume;
      delete actualData.cv;

      if (
        this.checkDiff(actualData, changedData) ||
        (this.deleteResume && this.tempResume !== "") ||
        this.profile.selectedFile ||
        (this.deleteCV && this.tempCV !== "") ||
        this.profile.cv_selectedFile
      ) {
        const res = await this.confirmSave();
        if (res) {
          const dataForm = new FormData();
          Object.keys(employmentData).forEach((key) =>
            dataForm.append(key, employmentData[key])
          );
          if (this.profile.file_name && this.profile.selectedFile) {
            dataForm.append(
              "resume",
              this.profile.selectedFile,
              this.profile.file_name
            );
          }
          if (this.profile.cv_file_name && this.profile.cv_selectedFile) {
            dataForm.append(
              "cv",
              this.profile.cv_selectedFile,
              this.profile.cv_file_name
            );
          }
          const success = await this.save(dataForm, "employment");
          if (success) {
            this.disableEmploymentCancel = false;
          }
        }
      } else if (!this.disableEmploymentCancel) {
        this.cancel();
      }
    },
    async confirmSave() {
      const res = await swal({
        title: "情報を更新しますか？",
        text:
          "登録企業への公開情報が更新されます。\n 書類（履歴書・職務経歴書等）をアップロードまたは更新した場合、\n 登録企業すべてに同じ書類が公開されます。",
        icon: "warning",
        className: "custom-swal",
        closeOnClickOutside: false,
        buttons: {
          cancel: "キャンセル",
          ok: {
            text: "更新する",
            value: true,
            visible: true,
            closeModal: false,
          },
        },
      });
      return res;
    },
    async save(data, url) {
      const check = await this.$validator.validateAll(url);
      if (check) {
        try {
          const token = await this.$auth.getToken();
          const headers = {
            Authorization: `Bearer ${token}`,
          };
          if (url == "employment") {
            headers["Content-Type"] = "multipart/form-data";
          }
          await this.axios({
            method: "post",
            data,
            url: Api.url(Api.endpoints[url]),
            headers,
          });

          if (url === "employment") {
            this.isEmploymentEdit = true;

            this.tempResume = "";
            this.deleteResume = false;
            this.profile.file_name = "";
            this.profile.selectedFile = "";
            this.$refs.inputFile.value = null;

            this.tempCV = "";
            this.deleteCV = false;
            this.profile.cv_file_name = "";
            this.profile.cv_selectedFile = "";
            this.$refs.cv_file.value = null;
            this.$refs.modal.hide();
            // swal("", "更新しました。", "success");
          }
          const content = document.createElement("span");
          content.innerHTML =
            '<p style="font-weight:bold">情報を更新しました。</p>';
          swal({
            title: "",
            content,
            className: "custom-swal4",
            icon: logo,
            buttons: {
              ok: "OK",
            },
          });
          this.clearErrors();
          return true;
        } catch (error) {
          if (error && error.response && error.response.status === 422) {
            this.server_errors = error.response.data;
          } else if (
            (error.response && error.response.status === 503) ||
            (error.response && error.response.status === 401)
          ) {
            this.$router.push({ name: "Logout" });
          } else {
            swal("", "Something Went Wrong", "error");
          }
          return false;
        } finally {
          swal.close();
        }
      } else {
        swal.close();
      }
    },
    clearErrors() {
      // clear errors
      this.errors.clear();
      this.server_errors = {};
    },
    clearServerError(name) {
      // clear server error of resume on file change
      const { [name]: exclude, ...newServerError } = this.server_errors;
      this.server_errors = { ...newServerError };
    },
    async onFileChanged(event) {
      try {
        const [...files] = event.target.files;
        // console.log(files[0]);
        // creating a clone to enable file upload from google drive
        const fileBuffer = await files[0].arrayBuffer();
        // console.log(fileBuffer);
        const clone = new File([fileBuffer], files[0].name, {
          type: files[0].type,
        });
        // console.log(clone);
        // // creating clone end
        [this.profile.file_name, this.profile.selectedFile] = [
          clone.name,
          clone,
        ];
        this.profile.resume = `/${this.profile.file_name}`;
        this.clearServerError("resume");
      } catch (err) {
        // swal("","Something Went Wrong! Please select your file again","error")
        // this.isEmploymentEdit = true;
        console.log(err);
      }
    },
    onClickDeleteFile(event) {
      event.preventDefault();
      this.deleteResume = true;
      this.profile.file_name = "";
      this.profile.selectedFile = "";
      this.$refs.inputFile.value = null;
      this.profile.resume = "";

      this.clearServerError("resume");
      this.$validator.validate("resume");
    },
    async onCVFileChanged(event) {
      try {
        const [...files] = event.target.files;
        const fileBuffer = await files[0].arrayBuffer();
        // console.log(fileBuffer);
        const clone = new File([fileBuffer], files[0].name, {
          type: files[0].type,
        });
        // console.log(clone);
        [this.profile.cv_file_name, this.profile.cv_selectedFile] = [
          clone.name,
          clone,
        ];

        this.profile.cv = `/${this.profile.cv_file_name}`;
        this.clearServerError("cv");
      } catch (err) {
        // swal("","Something Went Wrong! Please select your file again","error");
        // this.isEmploymentEdit= true
        console.log(err);
      }
    },
    onCVDeleteFile(event) {
      event.preventDefault();
      this.deleteCV = true;
      this.profile.cv_file_name = "";
      this.profile.cv_selectedFile = "";
      this.$refs.cv_file.value = null;
      this.profile.cv = "";

      this.clearServerError("cv");
      this.$validator.validate("cv");
    },
    toggleEdit() {
      if (this.profile.resume !== "") {
        this.tempResume = this.profile.resume;
      }

      if (this.profile.cv !== "") {
        this.tempCV = this.profile.cv;
      }

      this.tempEmploymentData.recent_registered_company_name = this.profile.recent_registered_company_name;
      // this.tempEmploymentData.years_of_attendance = this.profile.years_of_attendance;
      this.tempEmploymentData.latest_occupation_main_title = this.profile.latest_occupation_main_title;
      this.tempEmploymentData.latest_occupation_sub_title = this.profile.latest_occupation_sub_title;
      this.tempEmploymentData.employment_status = this.profile.employment_status;
      this.tempEmploymentData.position = this.profile.position;
      this.tempEmploymentData.english_skills = this.profile.english_skills;
      this.tempEmploymentData.last_year_income = this.profile.last_year_income;
      this.tempEmploymentData.number_of_experience_companies = this.profile.number_of_experience_companies;
      // this.tempEmploymentData.current_employment_situation = this.profile.current_employment_situation;
      this.tempEmploymentData.job_summary = this.profile.job_summary;
      this.tempEmploymentData.career_change_reason = this.profile.career_change_reason;
      this.tempEmploymentData.screening_intention = this.profile.screening_intention;
      this.tempEmploymentData.resume = this.profile.resume;
      this.tempEmploymentData.cv = this.profile.cv;
      // this.tempEmploymentData.job_history_record = this.profile.job_history_record;
      this.tempEmploymentData.currently_enrolled = this.profile.currently_enrolled;
      this.tempEmploymentData.enrollment_period_from = this.profile.enrollment_period_from;
      this.tempEmploymentData.enrollment_period_to = this.profile.enrollment_period_to;
    },
    cancel() {
      this.isEmploymentEdit = true;
      this.profile.recent_registered_company_name = this.tempEmploymentData.recent_registered_company_name;
      // this.profile.years_of_attendance = this.tempEmploymentData.years_of_attendance;
      this.profile.latest_occupation_main_title = this.tempEmploymentData.latest_occupation_main_title;
      this.profile.latest_occupation_sub_title = this.tempEmploymentData.latest_occupation_sub_title;
      this.profile.employment_status = this.tempEmploymentData.employment_status;
      this.profile.position = this.tempEmploymentData.position;
      this.profile.english_skills = this.tempEmploymentData.english_skills;
      this.profile.last_year_income = this.tempEmploymentData.last_year_income;
      this.profile.number_of_experience_companies = this.tempEmploymentData.number_of_experience_companies;
      // this.profile.current_employment_situation = this.tempEmploymentData.current_employment_situation;
      this.profile.job_summary = this.tempEmploymentData.job_summary;
      this.profile.career_change_reason = this.tempEmploymentData.career_change_reason;
      this.profile.screening_intention = this.tempEmploymentData.screening_intention;
      // this.profile.job_history_record = this.tempEmploymentData.job_history_record;
      this.profile.currently_enrolled = this.tempEmploymentData.currently_enrolled;
      this.profile.enrollment_period_from =
        this.tempEmploymentData.enrollment_period_from || "/";
      this.profile.enrollment_period_to =
        this.tempEmploymentData.enrollment_period_to || "/";
      if (this.profile.enrollment_period_from) {
        const [year, month] = this.profile.enrollment_period_from.split("/");
        this.enrollment_period.from.year = year;
        this.enrollment_period.from.month = month;
      }

      if (this.profile.enrollment_period_to) {
        const [year, month] = this.profile.enrollment_period_to.split("/");
        this.enrollment_period.to.year = year;
        this.enrollment_period.to.month = month;
      }
      
      this.profile.resume = this.tempResume;
      this.profile.file_name = "";
      this.profile.selectedFile = "";

      this.profile.cv = this.tempCV;
      this.profile.cv_file_name = "";
      this.profile.cv_selectedFile = "";

      this.deleteResume = false;
      this.tempResume = "";
      this.deleteCV = false;
      this.tempCV = "";
      this.clearErrors();
      this.$refs.modal.hide();
    },
    keepSelectionJobSubTitle(val) {
      if (val.trim()) {
        if (this.data.latestOccupation) {
          const parent = this.data.latestOccupation.find(
            ({ _id }) => _id === val
          );
          if (parent) {
            this.latestOccupationChilds = parent.children
              .filter((child) => child.status !== false)
              .sort((a, b) => a.position - b.position);
            const child = this.latestOccupationChilds.find(
              ({ _id }) => _id === this.profile.latest_occupation_sub_title
            );
            if (!child) this.profile.latest_occupation_sub_title = "";
          }
        }
      } else {
        this.latestOccupationChilds = [];
      }
    },
    getFileName(resume) {
      if (resume !== undefined) {
        if (resume != "") {
          const [folder, name] = resume.split("/");
          if (name) return name;
        }
      }
      return "";
    },
    previewFile(event, type) {
      event.preventDefault();
      this.getPreviewUrl(type);
    },
    async getPreviewUrl(type) {
      try {
        const token = await this.$auth.getToken();
        const response = await this.axios({
          method: "get",
          url: Api.url(Api.endpoints[type]),
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        const data = response.data;
        const win = window.open(data.signedUrl, "_blank");
        win.focus();
      } catch (error) {
        console.log(error);
      }
    },
  },
  mounted() {
    // check if enrolled period is updated or not if not then make employment section editable.
    if (this.profile.currently_enrolled === undefined) {
      this.toggleEdit();
      this.tempEmploymentData.currently_enrolled = false;
      this.tempEmploymentData.enrollment_period_from = "/";
      this.tempEmploymentData.enrollment_period_to = "/";
      this.disableEmploymentCancel = true;
    }
    this.$nextTick(()=>{
      if(this.$route.query.uploadFile === 'true'){
        this.showModal();
      } 
    })
  },
  created() {
    this.init_enrollment_period();
    const val = this.profile.latest_occupation_main_title;
    this.keepSelectionJobSubTitle(val);
  },
};
</script>
<style scoped>
@import url("../assets/css/shared.css");

.resume-group .invalid-feedback {
  text-align: left !important;
}

.resume-txt {
  display: block;
  max-width: 80vw;
  text-overflow: ellipsis;
  white-space: pre;
  overflow: hidden
}

.upld-file-name {
  justify-content: flex-start !important;
}

.upld-file-name p {
  white-space: pre !important;
  margin-left: 20px;
}

.upld-file-name i {
  margin-left: 20px;
}

.button-wrapper button {
  width: 35%;
}

.form-control.is-valid{
  background-image: none;
}
.form-control.is-invalid{
  background-image: none;
}
textarea::placeholder {
  font-size: 12px;
}

.btn-cstm {
  border-radius: 4px;
}

.btn-cstm.btn-cv-submit {
  font-weight: 500;
}

.btn-cstm-sm.btn-cv-delete {
  background-color: #787878;
  font-weight: 500;
}

.button-wrapper {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
}

.button-wrapper span {
  flex: 0.4;
}

/* .button-wrapper button {
  width: 90%;
} */

@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
  /* CSS rules for iPads in portrait mode */
  .button-wrapper {
    flex-direction: column;
  }
  .button-wrapper span {
    flex-basis: 100%;
  }
  .delete-button {
    margin-left: 0px !important;
    margin-top: 5px;
  }
  .button-wrapper button {
    width: 60%;
    margin: auto;
  }
  .upld-file-name {
    justify-content: center !important;
  }
  .upld-file-name p {
    white-space: pre !important;
    margin-left: 0px;
  }

  .upld-file-name i {
    margin-left: 10px;
  }
}

@media (max-width: 768px) {
  .button-wrapper {
    flex-direction: column;
  }
  .button-wrapper span {
    flex-basis: 100%;
  }
  .delete-button {
    margin-left: 0px !important;
    margin-top: 5px;
  }

  .button-wrapper button {
    width: 60%;
    margin: auto;
  }

  .upld-file-name {
    justify-content: center !important;
  }

  .upld-file-name p {
    white-space: pre !important;
    margin-left: 0px;
  }

  .upld-file-name i {
    margin-left: 10px;
  }
}

@media (max-width: 480px) {
  .button-wrapper button {
    width: 80%;
    margin: auto;
  }
  .upld-file-name p {
    white-space: pre !important;
    margin-left: 0px;
  }

  .upld-file-name i {
    margin-left: 10px;
  }

}


>>> .sharingTitle {
  margin-top: 5px;
  color: black !important;
  font-weight: 600;
}
</style>
